































































import ErrorAlert from '@/components/common/ErrorAlert.vue';
import {
  EmployeeWorkScheduleFieldError,
  IWorkDayData,
  ScheduleWorkDay,
  DayType,
  IEmployee,
  IScheduleWorkDayData,
  IEmployeeWorkScheduleData
} from '@/models';

import { mapActions, mapGetters } from 'vuex';
import { cloneDeep } from 'lodash';
import auth from '@/mixins/auth';
import mixins from '@/utils/mixins';
import { diffDeep } from '@/utils/helpers';
import { PropType } from 'vue';

import { factory as Proxyable } from '@/mixins/proxyable';

export default mixins(
  auth,
  Proxyable<'value', IEmployeeWorkScheduleData>()
).extend({
  name: 'EmployeeScheduleDetailFormCard',

  components: {
    ErrorAlert
  },

  props: {
    externalEmployee: {
      type: Object as PropType<IEmployee>
    },

    fieldError: {
      type: Object,
      default: () => new EmployeeWorkScheduleFieldError()
    }
  },

  data() {
    return {
      requiredRules: [(v: number) => !!v || 'This field is required'],
      hourRules: [
        (v: number) => {
          if (v) {
            return v <= 24 || 'Hours should not be more than 24';
          }
          return true;
        }
      ]
    };
  },

  computed: {
    ...mapGetters({
      getEmployeeWorkSchedule: 'employee/getEmployeeWorkSchedule'
    }),

    isEdit(): boolean {
      return !!(
        this.getEmployeeWorkSchedule &&
        this.getEmployeeWorkSchedule.employee == this.externalEmployee?.id
      );
    },

    scheduledDays: {
      get(): number[] {
        return [...this.internalValue.scheduled_days!]
          .sort()
          .map(scheduledDay =>
            (scheduledDay as IScheduleWorkDayData).workday != null
              ? (scheduledDay as IScheduleWorkDayData).workday!
              : (scheduledDay as number)
          );
      },
      set(value: IScheduleWorkDayData[] = []) {
        this.internalValue.scheduled_days = value;
      }
    },

    workDaysList(): IWorkDayData[] {
      return [
        {
          value: DayType.Sunday,
          name: DayType[DayType.Sunday]
        },

        {
          value: DayType.Monday,
          name: DayType[DayType.Monday]
        },

        {
          value: DayType.Tuesday,
          name: DayType[DayType.Tuesday]
        },

        {
          value: DayType.Wednesday,
          name: DayType[DayType.Wednesday]
        },

        {
          value: DayType.Thursday,
          name: DayType[DayType.Thursday]
        },

        {
          value: DayType.Friday,
          name: DayType[DayType.Friday]
        },

        {
          value: DayType.Saturday,
          name: DayType[DayType.Saturday]
        }
      ];
    }
  },

  methods: {
    ...mapActions({
      createEmployeeWorkSchedule: 'employee/createEmployeeWorkSchedule',
      updateEmployeeWorkSchedule: 'employee/updateEmployeeWorkSchedule'
    }),

    clearAllErrors(): void {
      this.$emit('clearAllErrors');
    },

    /**
     * @public Is used outside component
     *
     */
    async saveEmployeeWorkSchedule(): Promise<void> {
      this.clearAllErrors();

      const employee = cloneDeep(this.internalValue);

      // delegate error handling to parent component

      if (this.isEdit) {
        const employeeId = employee.employee;
        const employeeDelta = diffDeep(
          employee,
          this.getEmployeeWorkSchedule,
          false
        );

        employeeDelta.employee = employeeId;

        await this.updateEmployeeWorkSchedule(
          this.buildScheduleWorkDays(employeeDelta)
        );
      } else {
        await this.createEmployeeWorkSchedule(
          this.buildScheduleWorkDays(employee)
        );
      }
    },

    buildScheduleWorkDays(employeeWorkSchedule: IEmployeeWorkScheduleData) {
      if (employeeWorkSchedule.scheduled_days) {
        employeeWorkSchedule.scheduled_days = employeeWorkSchedule.scheduled_days.map(
          (workday: number | IScheduleWorkDayData) => {
            if (typeof workday == 'number') {
              return new ScheduleWorkDay({
                workday: workday as number
              });
            } else {
              return workday;
            }
          }
        );
      }
      return employeeWorkSchedule;
    }
  }
});
